import { Markdown } from '@cibo/ui'
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { Box, Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, LinkProps } from 'react-router-dom'

interface FinishEnrollmentCTAProps extends Pick<LinkProps, 'to'> {
  markdown: string
}

export const FinishEnrollmentCTA = ({ markdown, to }: FinishEnrollmentCTAProps) => {
  const { t } = useTranslation('pages/Programs/ProgramDetail/FinishEnrollmentCTA')
  return (
    <Stack>
      <Box maxWidth={500}>
        <Markdown color="text.secondary">{markdown}</Markdown>
      </Box>
      <Box>
        <Button
          variant="contained"
          color="warning"
          size="large"
          component={Link}
          to={to}
          endIcon={<ChevronRightRounded />}
        >
          {t('finishEnrollment')}
        </Button>
      </Box>
    </Stack>
  )
}
